import { render, staticRenderFns } from "./ImgBlock.vue?vue&type=template&id=9af331dc&scoped=true"
import script from "./ImgBlock.vue?vue&type=script&lang=js"
export * from "./ImgBlock.vue?vue&type=script&lang=js"
import style0 from "./ImgBlock.vue?vue&type=style&index=0&id=9af331dc&prod&lang=scss"
import style1 from "./ImgBlock.vue?vue&type=style&index=1&id=9af331dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af331dc",
  null
  
)

export default component.exports